export const SHEET_CONFIG = {
  // ============================================================================
  // CLIENT GUIDE: GOOGLE SHEETS CONFIGURATION
  // ============================================================================
  // 
  // 1. PUBLIC SPREADSHEET ID (For reading data)
  // How to get it:
  // - Open your Google Sheet
  // - Go to File -> Share -> Publish to web
  // - Select "Entire Document" and "Web page", then click Publish
  // - Close the publish dialog, look at the URL in your browser
  // - The ID is the long string of characters between /d/ and /edit
  // - Note: For published sheets, it often starts with 2PACX-
  spreadsheetId: '', // e.g., '2PACX-1vTSM9XPl-Ti4Fz9Hr2BMk8dwzw5nP8KUjPx...'

  // 2. PRIVATE SPREADSHEET ID (For writing data via Webhooks)
  // How to get it:
  // - Look at the URL of your Google Sheet: https://docs.google.com/spreadsheets/d/YOUR_SHEET_ID/edit
  // - Copy YOUR_SHEET_ID and paste it here
  editSpreadsheetId: '', // e.g., '1n6EHTmx5hgFXC9vgPVgHGMDo660_N-uIXIBPIoQtl7I'

  // ============================================================================
  // 3. TAB GIDs (Sub-sheet IDs)
  // ============================================================================
  // How to get them:
  // - Click on each specific tab at the bottom of your Google Sheet
  // - Look at the URL, it will end with #gid=123456789
  // - Copy the number after "gid=" for each corresponding tab below
  gids: {
    campaigns: '',      // e.g., '0'
    leads: '',          // e.g., '570407358'
    content: '',        // e.g., '942763469'
    roi: '',            // e.g., '974136326'
    broadcasts: '',     // e.g., '522078397'
    quotations: '',     // e.g., '1657575300'
    dealerSchemes: '',  // e.g., '236984820'
    fieldSales: '',     // e.g., '1949005463'
    onboarding: '',     // e.g., '248917198'
    testimonials: '',   // e.g., '1948341797'
    customer: '',       // e.g., '706168239'
  },

  // ============================================================================
  // 4. WEBHOOK URLs
  // ============================================================================
  // Replace these with your own webhook URLs if you are using Pucho Studio or another automation tool.
  webhookUrls: {
    campaignManagement: '',
    leadTracking: '',
    roiCalculator: '',
    contentCalendar: '',
    broadcast: '',
    dataSync: '',
    onboarding: '',
    testimonials: '',
  }
};
